/**
 * Initializes input element with value
 * @param {HTMLInputElement | HTMLSelectElement} input
 * @param {string} value
 * @returns {HTMLInputElement | HTMLSelectElement}
 */
export function updateInput(input, value) {
  input.value = value.replace('%40', '@') //I don't want to completely decode this to avoid any shenanigans, so let's support it by character
  return input
}
